/**
 * Initializes copy-to-clipboard functionality for elements with the .ecux-copy-btn class.
 *
 * When a button with .ecux-copy-btn is clicked, it copies the text content of the target element
 * (specified by the button's data-target attribute) to the clipboard. The button receives a 'copied'
 * class for 1 second to allow for visual feedback (e.g., a tooltip or style change).
 *
 * Usage:
 *   - Call initCopyToClipboard() to manually initialize, or import and use the exported init method.
 *   - The script auto-initializes on DOMContentLoaded if run in a browser environment.
 *
 * Example HTML:
 *   <div id="my-value">Some text</div>
 *   <button class="ecux-copy-btn" data-target="#my-value">Copy</button>
 *
 * Example JS:
 *   const copyToClipboard = require('./copyToClipboard');
 *   copyToClipboard.init();
 */
function initCopyToClipboard() {
    document.querySelectorAll('.ecux-copy-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            var targetSelector = btn.getAttribute('data-target');
            if (!targetSelector) return;
            var target = document.querySelector(targetSelector);
            if (!target) return;
            var text = target.textContent || target.innerText || '';
            if (!text) return;
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text).then(function() {
                    btn.classList.add('copied');
                    setTimeout(function() { btn.classList.remove('copied'); }, 1000);
                });
            } else {
                var textarea = document.createElement('textarea');
                textarea.value = text;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                btn.classList.add('copied');
                setTimeout(function() { btn.classList.remove('copied'); }, 1000);
            }
        });
    });
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', initCopyToClipboard);
}

module.exports = {
    init: initCopyToClipboard
};
